"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tenant = exports.SharedDataType = exports.OrgType = void 0;
var OrgType;
(function (OrgType) {
    OrgType["CARRIER"] = "carrier";
    OrgType["CHARTERING_OFFICE"] = "chartering-office";
    OrgType["ORGANIZATION"] = "organization";
})(OrgType = exports.OrgType || (exports.OrgType = {}));
var SharedDataType;
(function (SharedDataType) {
    SharedDataType["CHARTERING"] = "chartering";
    SharedDataType["SENN_TMS"] = "senn_tms";
    SharedDataType["ORCAS"] = "orcas";
    SharedDataType["ORCAS_MOBILE"] = "orcas_mobile";
    SharedDataType["OCTOPUS"] = "octopus";
    SharedDataType["OTTERS"] = "otters";
    SharedDataType["WIDGET"] = "widget";
    SharedDataType["ONBOARDING"] = "onboarding";
})(SharedDataType = exports.SharedDataType || (exports.SharedDataType = {}));
var Tenant;
(function (Tenant) {
    Tenant["SENNDER"] = "sennder";
    Tenant["POSTE"] = "poste";
    Tenant["DEMO"] = "demo";
})(Tenant = exports.Tenant || (exports.Tenant = {}));
